/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [like-navigation.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 21.02.20, 15:32
 */

import React, {useRef} from 'react';
import {connect} from 'react-redux';

import {EmojiButton} from "../navigation/buttons/nav-buttons";
import {asyncCreatePostLike, asyncRemovePostLike,} from "../../actions";
import {getAuthorizedUsername, useAuthorization} from "../../selectors";
import LikeNavigationTooltip from "./like-navigation-tooltip";
import {ANGRY, HAHA, LIKE, LOVE, SAD, WOW} from "./like-reaction-info";
import {
    FaceLaughIcon,
    FaceSurpriseIcon,
    FavoriteIcon2, fs_regular, fs_small, fs_smaller,
    PersonAngryIcon,
    PersonSadIcon,
    ThumbUpIcon
} from "../navigation/icons/nav-icons";
import {notifyWarning} from "../notifications/notify";
import {useLanguage} from "../configuration/configuration";


// TODO refactor to use useSelector(state..) and hooks instead of mapstatetoprops for redux
const LikeNavigation = (props) => {
    const indexedReactions = useRef({});
    const ownReaction = useRef( {liked: null, likedId: null, username: null});
    const {isAuthorized} = useAuthorization();
    const Lang = useLanguage();

    const handleLikePost = (event, reaction) => {
        event.preventDefault();
        const {authname, postId} = props;

        return isAuthorized ?
            props.asyncCreatePostLike(authname, postId, {username: authname, reaction: reaction}) :
            notifyWarning(Lang.access.mustLogin.liken);
    };

    const handleUnlikePost = (event, reaction) => {
        event.preventDefault();
        const {authname, postId} = props;
        const {likedId} = ownReaction.current;

        return isAuthorized ?
            props.asyncRemovePostLike(authname, postId, likedId, () => {
                ownReaction.current = {liked: null, likedId: null, username: null};
            }) : notifyWarning(Lang.access.mustLogin.liken);
    };


    const buildIndexedReactions = (authname, likes) => {
        const index = {[LIKE]: [], [LOVE]: [], [HAHA]: [], [WOW]: [], [SAD]: [], [ANGRY]: []};

        likes.forEach(like => {
            if (authname === like.user.username) {
                ownReaction.current = {username: authname, liked: like.reaction, likedId: like.id};
            }
            index[like.reaction].push(like);
        });

        indexedReactions.current = index;
    };

    const getEmojiIcon = (reaction) => {
        switch(reaction) {
            case LIKE: return <ThumbUpIcon size={fs_regular}/>
            case LOVE: return <FavoriteIcon2 size={fs_regular}/>
            case HAHA: return <FaceLaughIcon size={fs_small}/>
            case WOW: return <FaceSurpriseIcon size={fs_small}/>
            case SAD: return <PersonSadIcon size={fs_regular}/>
            case ANGRY: return <PersonAngryIcon size={fs_regular}/>
        }
    }

    const renderLikeEntries = () => {
        const reactions = indexedReactions.current;
        const {liked} = ownReaction.current;

        return [LIKE, LOVE, HAHA, WOW, SAD, ANGRY].map(reaction => {
            const selected = liked && reaction === liked;
            const disabled = liked && reaction !== liked;

            if(liked && reactions[reaction].length === 0) return "";

            return <div key={reaction} className="like-entry clr-dark-gray">
                {!liked && <EmojiButton onClick={event => handleLikePost(event, reaction)}>
                    {getEmojiIcon(reaction)}
                </EmojiButton>}
                {selected && <EmojiButton selected
                                    onClick={event => handleUnlikePost(event, reaction)}>
                    {getEmojiIcon(reaction)}
                </EmojiButton>}
                {disabled && <EmojiButton disabled>
                    {getEmojiIcon(reaction)}
                </EmojiButton>}

                <LikeNavigationTooltip reaction={reaction} likes={reactions[reaction]}/>
            </div>
        })
    };

    const {postId, likes, authname} = props;
    buildIndexedReactions(authname, likes);

    return <div className='like-navigation mt-1'>
        {renderLikeEntries()}
    </div>
};

const mapStateToPros = (state, ownProps) => ({
    likes: state.likes[ownProps.postId] ? state.likes[ownProps.postId] : [],
    authname: getAuthorizedUsername(state),
});

export default connect(mapStateToPros, {asyncCreatePostLike, asyncRemovePostLike})(LikeNavigation);

